import { Pipe, PipeTransform } from '@angular/core';
import { GlobalService } from 'app/global/global.service';
import { Field } from 'app/interfaces/fields';

@Pipe({
  name: 'getDroplistName',
})
export class GetDroplistNamePipe implements PipeTransform {
    constructor(private globalService: GlobalService) {}
  transform(value: string, field: Field) {
    if(field?.selected_option_id){
        if(Array.isArray(field?.selected_option_id)){
          const selectedDroplistValues = field.selected_option_id.map(id => this.globalService.findDroplistById(field.uuid, id)?.name).filter(Boolean);
          return selectedDroplistValues.length ? selectedDroplistValues : value;
        }else{
          const selectedDroplistValue = this.globalService.findDroplistById(field.uuid, field?.selected_option_id);
          return selectedDroplistValue ? selectedDroplistValue.name : value;
        }
    }
    return value;
  }
}